import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Helmet} from 'react-helmet-async'

const About: FC = () => {
  const intl = useIntl()
  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({id: 'ABOUT.META.TITLE'})}</title>
        <meta name='description' content={intl.formatMessage({id: 'ABOUT.META.DESC'})} />
        <meta property='og:title' content={intl.formatMessage({id: 'ABOUT.META.TITLE'})} />
        <meta property='og:description' content={intl.formatMessage({id: 'ABOUT.META.DESC'})} />
      </Helmet>

      {/* Hero Section */}
      <section className='hero-section contact-hero mt-2'>
        <div className='hero-content'>
          <div className='mb-4'>
            <span className='badge px-4 py-2 rounded-pill'>
              <KTIcon iconName='people' className='fs-2 text-warning ms-2' />
              {intl.formatMessage({id: 'ABOUT.HERO.BADGE'})}
            </span>
          </div>
          <h1 className='hero-title'>{intl.formatMessage({id: 'ABOUT.HERO.TITLE'})}</h1>
          <p className='hero-desc'>
            {intl.formatMessage({id: 'ABOUT.HERO.DESC1'})}
          </p>
          <p className='hero-desc'>
            {intl.formatMessage({id: 'ABOUT.HERO.DESC2'})}
          </p>
        </div>
        <div className='hero-image'>
          <img
            src={toAbsoluteUrl('/media/illustrations/energy/sun-contract-bg-top-medium4.webp')}
            alt='درباره سیگنال‌های معاملاتی'
            style={{maxWidth: 570}}
          />
        </div>
        <button
          className='hero-scroll-btn'
          onClick={() => {
            const nextSection = document.getElementById('first-content-section')
            if (nextSection) nextSection.scrollIntoView({behavior: 'smooth'})
          }}
          aria-label={intl.formatMessage({id: 'COMMON.SCROLL_DOWN'})}
        >
          <svg
            className='hero-scroll-svg'
            width='120'
            height='64'
            viewBox='0 0 120 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M88.0935 28C88.0935 12.536 75.3811 0 59.6996 0C44.0181 0 31.3057 12.536 31.3057 28C31.3057 43.464 44.0181 56 59.6996 56C75.3811 56 88.0935 43.464 88.0935 28Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M39.5969 8.86421C32.3121 15.6129 24.4015 27.5594 4.6961 27.8366C-15.0093 28.1137 33.673 39.7129 33.673 39.7129C33.673 39.7129 46.8818 2.11406 39.5969 8.86421Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M80.4024 8.86412C86.625 16.1764 95.5975 27.5595 115.304 27.8366C135.01 28.1138 86.3273 39.7129 86.3273 39.7129C86.3273 39.7129 74.1798 1.55253 80.4024 8.86412Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M54.6667 22.3334L60 27.6667L65.3334 22.3334'
              stroke='#19191A'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            ></path>
          </svg>
        </button>
      </section>

      {/* سوابق اجرایی */}
      <section id='first-content-section' className='achievements-section py-20'>
        <div className='container'>
          <h2 className='text-center mb-4 section-title'>{intl.formatMessage({id: 'ABOUT.SECTION.EXEC_TITLE'})}</h2>
          <p className='text-center mb-10 text-gray-600 fs-5 section-desc'>
            {intl.formatMessage({id: 'ABOUT.SECTION.EXEC_DESC'})}
          </p>
          <div className='achievements-grid'>
            {['chart', 'bitcoin', 'technology', 'book', 'sun', 'rocket'].map((icon, i) => (
              <div className='achievement-card' key={i}>
                <div className='achievement-icon'>
                  <KTIcon iconName={icon} className='fs-2x text-primary' />
                </div>
                <div className='achievement-year'>{intl.formatMessage({id: `ABOUT.EXEC.${i + 1}.YEAR`})}</div>
                <h4 className='achievement-title'>{intl.formatMessage({id: `ABOUT.EXEC.${i + 1}.TITLE`})}</h4>
                <p className='achievement-desc'>{intl.formatMessage({id: `ABOUT.EXEC.${i + 1}.DESC`})}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ماموریت و چشم‌انداز */}
      <section className='mission-vision-section mission-vision-section-about py-20'>
        <div className='container'>
          <h2 className='text-center mb-8 section-title'>{intl.formatMessage({id: 'ABOUT.MISSION.TITLE'})}</h2>
          <div className='row g-5 justify-content-center'>
            <div className='col-md-6 col-12'>
              <div className='mv-card h-100'>
                <div className='mv-image-wrapper mb-4'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/weCan-2.svg')}
                    alt={intl.formatMessage({id: 'ABOUT.MISSION.MISSION_TITLE'})}
                    className='mv-image'
                  />
                </div>
                <h3 className='mv-title'>{intl.formatMessage({id: 'ABOUT.MISSION.MISSION_TITLE'})}</h3>
                <p className='mv-desc'>
                  {intl.formatMessage({id: 'ABOUT.MISSION.MISSION_DESC'})}
                </p>
                <div className='mv-features'>
                  <div className='mv-feature'>
                    <KTIcon iconName='shield-tick' className='mv-feature-icon' />
                    <span>{intl.formatMessage({id: 'ABOUT.MISSION.HIGH_ACCURACY'})}</span>
                  </div>
                  <div className='mv-feature'>
                    <KTIcon iconName='user' className='mv-feature-icon' />
                    <span>{intl.formatMessage({id: 'ABOUT.MISSION.SUPPORT_24'})}</span>
                  </div>
                  <div className='mv-feature'>
                    <KTIcon iconName='code' className='mv-feature-icon' />
                    <span>{intl.formatMessage({id: 'ABOUT.MISSION.ADVANCED_ANALYSIS'})}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-12'>
              <div className='mv-card h-100'>
                <div className='mv-image-wrapper mb-8'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/weCan-1.svg')}
                    alt={intl.formatMessage({id: 'ABOUT.MISSION.VISION_TITLE'})}
                    className='mv-image-2 m-5'
                  />
                </div>
                <h3 className='mv-title'>{intl.formatMessage({id: 'ABOUT.MISSION.VISION_TITLE'})}</h3>
                <p className='mv-desc'>
                  {intl.formatMessage({id: 'ABOUT.MISSION.VISION_DESC'})}
                </p>
                <div className='mv-features mt-15'>
                  <div className='mv-feature'>
                    <KTIcon iconName='abstract-26' className='mv-feature-icon' />
                    <span>{intl.formatMessage({id: 'ABOUT.MISSION.GLOBAL_NETWORK'})}</span>
                  </div>
                  <div className='mv-feature'>
                    <KTIcon iconName='share' className='mv-feature-icon' />
                    <span>{intl.formatMessage({id: 'ABOUT.MISSION.CONTINUOUS_EDU'})}</span>
                  </div>
                  <div className='mv-feature'>
                    <KTIcon iconName='bank' className='mv-feature-icon' />
                    <span>{intl.formatMessage({id: 'ABOUT.MISSION.SUSTAINABLE_PROFIT'})}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* تیم ما */}
      <section className='team-section py-20'>
        <div className='container'>
          <h2 className='text-center mb-4 section-title'>{intl.formatMessage({id: 'ABOUT.TEAM.TITLE'})}</h2>
          <p className='text-center mb-10 text-gray-600 fs-5 section-desc'>
            {intl.formatMessage({id: 'ABOUT.TEAM.DESC'})}
          </p>
          <div className='row g-5 justify-content-center'>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((idx) => (
              <div className='col-lg-3 col-md-4 col-sm-6 col-12' key={idx}>
                <div className='team-card'>
                  <div className='team-image-wrapper'>
                    <img
                      src={toAbsoluteUrl('/media/avatars/blank.png')}
                      alt={intl.formatMessage({id: `ABOUT.TEAM.${idx}.NAME`})}
                      className='team-image'
                    />
                  </div>
                  <div className='team-content'>
                    <h4 className='team-name'>{intl.formatMessage({id: `ABOUT.TEAM.${idx}.NAME`})}</h4>
                    <div className='team-position'>{intl.formatMessage({id: `ABOUT.TEAM.${idx}.POSITION`})}</div>
                    <div className='team-role'>{intl.formatMessage({id: `ABOUT.TEAM.${idx}.ROLE`})}</div>
                    <p className='team-desc'>{intl.formatMessage({id: `ABOUT.TEAM.${idx}.DESC`})}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* کال تو اکشن نهایی */}
      <section className='final-cta-section final-cta-section-about'>
        <div className='container'>
          <div className='cta-card'>
            <div className='cta-content cta-content-about'>
              <h2 className='cta-title'>{intl.formatMessage({id: 'ABOUT.CTA.TITLE'})}</h2>
              <p className='cta-description'>
                {intl.formatMessage({id: 'ABOUT.CTA.DESC'})}
              </p>
              <div className='cta-actions'>
                <Link to='/contact' className='btn btn-secondary btn-lg px-6'>
                  {intl.formatMessage({id: 'ABOUT.CTA.BUTTON'})}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export {About}
